/* Mirrors the columns computed in feature-strip.tsx (isSm/isLg from
   src/hooks/use-breakpoint.ts: sm=640, lg=1024) and Spacing.two/three from
   src/constants/theme.ts — keep in sync if those change.

   Grid-based column count instead of a JS-measured `itemWidth` (useState +
   onLayout) avoids the post-mount snap from 1 -> 2 -> 4 columns that showed
   up as a height jump once the page-level layout flash was fixed. */

.wrap {
  padding: 0 16px;
}

@media (min-width: 1024px) {
  .wrap {
    padding: 0;
  }
}

.grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
}

@media (min-width: 640px) {
  .grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 1024px) {
  .grid {
    grid-template-columns: repeat(4, 1fr);
  }
}
